<template>
  <v-sheet class="overflow-hidden" style="background-color: transparent">
    <v-container class="fill-height" :style="firstPanelisSmall ? 'padding: 2px 10px' : 'padding: 0'">
      <v-row
        align="center"
        justify="start"
        :class="firstPanelisSmall ? '' : ''"
        :style="firstPanelisSmall ? 'margin: 0 2px 0 0px' : 'padding: 0px 3px; margin: 0 2px 0 8px'"
      >
        <v-btn v-if="!firstPanelisSmall" text block color="#ccc" @click.stop="drawer = !drawer">
          <span class="material-icons-round mr-2" style="font-size: 17px">keyboard</span>
          {{ 'ShortCuts' }}
        </v-btn>
        <v-btn
          v-else
          text
          block
          color="#ccc"
          :style="firstPanelisSmall ? 'justify-content: center !important' : ''"
          @click.stop="drawer = !drawer"
        >
          <span class="material-icons-round" style="font-size: 17px">keyboard</span>
        </v-btn>
      </v-row>
    </v-container>

    <v-navigation-drawer
      v-model="drawer"
      right
      dark
      style="position: fixed; top: 60px; height: calc(100% - 85px) !important; z-index: 301"
    >
      <v-list-item>
        <v-list-item-icon v-if="selectedItem" @click="selectedItem = null">
          <v-btn plain><span class="material-icons-round" style="font-size: 18px">west</span></v-btn>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-if="selectedItem">{{ selectedItem }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-btn plain>
            <span class="material-icons-round" style="font-size: 18px" @click.stop="drawer = !drawer" translate="no">
              close
            </span>
          </v-btn>
        </v-list-item-icon>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense v-if="!selectedItem">
        <v-list-item v-for="item in items" :key="item.title" link @click="clickItem(item.title)">
          <v-list-item-icon>
            <span class="material-icons-round mr-1">{{ item.icon }}</span>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <transition name="fade" mode="out-in">
        <v-list v-if="selectedItem == 'Keyboard Shortcuts'" class="container-shotcut">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search shortcuts"
            single-line
            hide-details
            class="mb-5"
          ></v-text-field>

          <span v-if="interactionFilteredItems.length > 0" class="title-shortcut">Interaction</span>
          <v-list v-for="item in interactionFilteredItems" :key="item.desc">
            <div class="container-kbd-key">
              <span class="kbd-key">{{ item.key }}</span>
            </div>
            <span class="desc-shortcut">{{ item.desc }}</span>
          </v-list>

          <span v-if="mediaFilteredItems.length > 0" class="title-shortcut">Media Control</span>
          <v-list v-for="item in mediaFilteredItems" :key="item.desc">
            <div v-if="item.key2" class="container-kbd-key">
              <span class="kbd-key">{{ item.key }}</span>
              <span class="kbd-key">{{ item.key2 }}</span>
            </div>
            <div v-else class="container-kbd-key">
              <span class="kbd-key">{{ item.key }}</span>
            </div>
            <span class="desc-shortcut">{{ item.desc }}</span>
          </v-list>
        </v-list>
      </transition>
    </v-navigation-drawer>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  name: 'HelpSupport',
  props: { firstPanelisSmall: Boolean },
  created() {
    this.getDrawer = this.$route.meta.sidebar
    this.drawerPosition = this.$route.meta.sidebarPosition
  },
  data() {
    return {
      drawer: false,
      items: [{ title: 'Keyboard Shortcuts', icon: 'keyboard' }],
      selectedItem: null,
      search: '',
      searchItem: [],
      interactionShortcuts: [
        {
          key: 'R',
          desc: 'Start Recording',
          category: 'interaction',
        },
        {
          key: 'S',
          desc: 'Share',
          category: 'interaction',
        },
        {
          key: 'C',
          desc: 'Start writing a comment',
          category: 'interaction',
        },
        {
          key: 'D',
          desc: 'Peek into clip (hover and hold)',
          category: 'interaction',
        },
      ],
      mediaShortcuts: [
        {
          key: 'K',
          desc: 'Play / Pause',
          category: 'media',
        },
        {
          key: 'M',
          desc: 'Mute / Unmute',
          category: 'media',
        },
        {
          key: 'F',
          desc: 'Full Screen (Video only)',
          category: 'media',
        },
        {
          key: 'V',
          desc: 'Visual comment select box',
          category: 'media',
        },
        {
          key: '←',
          desc: 'Seek backward 5 secs',
          category: 'media',
        },
        {
          key: '→',
          desc: 'Seek forward 5 secs',
          category: 'media',
        },
        {
          key: '↑',
          desc: 'Increase volume',
          category: 'media',
        },
        {
          key: '↓',
          desc: 'Decrease volume',
          category: 'media',
        },
        {
          key: '⇧',
          key2: '←',
          desc: 'Move to the previous clip',
          category: 'media',
        },
        {
          key: '⇧',
          key2: '→',
          desc: 'Move to the next clip',
          category: 'media',
        },
        {
          key: '<',
          desc: 'Decrease playback speed',
          category: 'media',
        },
        {
          key: '>',
          desc: 'Increase playback speed',
          category: 'media',
        },
        {
          key: 'W',
          desc: 'Open Watch modal',
          category: 'media',
        },
      ],
    }
  },
  mounted() {
    // const fullShortcuts = [...this.interactionShortcuts, ...this.mediaShortcuts]
    setTimeout(() => (this.interactionSearchItem = this.interactionShortcuts))
    setTimeout(() => (this.mediaSearchItem = this.mediaShortcuts))

    document.addEventListener('keydown', this.keyEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    clickItem(item) {
      this.selectedItem = item
    },
    keyEvent(e) {
      // esc 누르면 다이얼로그 닫기
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        if (e.keyCode == 27) {
          this.drawer = false
          e.preventDefault()
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'currentMt',
      'userWsList',
      'selectedWsInfo',
      'chList',
      'assignedInfo',
      'selectedCh',
      'isWsOwner',
      'isWsManager',
      'wsClipCnt',
    ]),
    interactionFilteredItems() {
      return this.interactionSearchItem.filter((item) => {
        return item.key.toLowerCase().match(this.search) || item.desc.toLowerCase().match(this.search)
      })
    },
    mediaFilteredItems() {
      return this.mediaSearchItem.filter((item) => {
        return item.key.toLowerCase().match(this.search) || item.desc.toLowerCase().match(this.search)
      })
    },
  },
  watch: {
    search(val) {
      if (!val) {
        setTimeout(() => (this.interactionSearchItem = this.interactionShortcuts))
        setTimeout(() => (this.mediaSearchItem = this.mediaShortcuts))
      }
    },
    drawer(val) {
      // 지금은 메뉴가 단축키 밖에 없어서 자동 진입하도록 처리
      if (val) this.clickItem('Keyboard Shortcuts')
    },
  },
}
</script>

<style scoped>
button >>> span {
  font-weight: 400;
}
.v-btn {
  padding: 0 8px !important;
  min-width: 0 !important;
  height: 30px !important;
  justify-content: start;
}
.v-navigation-drawer {
  height: calc(100% - 20px) !important;
  margin: 10px;
  border-radius: 5px;
  width: 350px !important;
  background-color: #1d292f;
  border: 1px solid #475e69;
}
.v-list-item__icon {
  margin-right: 5px !important;
}
.v-list-item__title {
  font-size: 14px;
}
.container-shotcut {
  padding: 20px;
  font-size: 13px;
  height: auto !important;
}
.container-shotcut .v-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.container-kbd-key {
  display: inline-block;
  width: 85px;
  text-align: left;
}
.kbd-key {
  display: inline-block;
  box-sizing: border-box;
  background-color: #ccc;
  margin: 2px;
  border-radius: 4px;
  border: solid #121c20;
  border-width: 1px 1px 2px;
  padding: 1px 2px;
  color: #161d21;
  font-size: 12px;
  font-weight: 700;
  min-width: 24px;
  text-align: center;
  letter-spacing: -1px;
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.1);
}
.desc-shortcut {
  display: inline-flex;
}
.btn-shortcut {
  position: absolute;
  top: 30px;
  left: -85px;
  -webkit-transform: rotate(270deg) translatez(0);
  transform: rotate(270deg) translatez(0);
  margin-top: 50px;
  color: #ccc;
  font-size: 15px;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  height: 45px !important;
}
.btn-shortcut >>> span {
  display: inline-block;
  color: #ccc;
  font-size: 13px;
}
.title-shortcut {
  display: block;
  font-size: 12px;
  text-align: right;
  color: #999;
  margin: 10px 0 5px 0;
}
.fade-leave-to {
  opacity: 0;
  transition: opacity 0s ease;
}
</style>
